export default "__VITE_ASSET__iRmnP3q0__"